import { Card, Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import {
  ApiOutlined,
  DollarOutlined,
  FileSearchOutlined,
  GiftOutlined,
  HistoryOutlined,
  LinkOutlined,
  UserOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

const features = [
  {
    icon: <LinkOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Link Account',
    description: 'Link an existing NHSV trading account to a new Stag user account.',
    href: '/nhsv/link-account',
  },
  {
    icon: <UserOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Lookup by ID',
    description: 'Look up an NHSV trading account by national ID number (CCCD/CMND).',
    href: '/nhsv/lookup-account',
  },
  {
    icon: <FileSearchOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Account Detail',
    description: 'View full account info, asset summary, stock positions, and cash balance.',
    href: '/nhsv/account-detail',
  },
  {
    icon: <HistoryOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Order History',
    description: 'Browse trading order history with date range filtering and pagination.',
    href: '/nhsv/order-history',
  },
  {
    icon: <GiftOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Rights History',
    description: 'Check the raw rights lists from NHSV (ASSET-010 to 017) for an account.',
    href: '/nhsv/rights-history',
  },
  {
    icon: <GiftOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'App Rights View',
    description: 'See the shareholder rights an account sees in the app, from the same service.',
    href: '/nhsv/app-rights',
  },
  {
    icon: <ApiOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Webhook Configs',
    description: 'Manage NHSV webhook endpoint configurations, retry policies, and secrets.',
    href: '/nhsv/webhook-configs',
  },
  {
    icon: <DollarOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Securities Price',
    description: 'Fetch live securities price directly from NHSV, bypassing our sync jobs.',
    href: '/nhsv/securities-price',
  },
];

export default function NHSVHomePage() {
  return (
    <div style={{ padding: 32 }}>
      <Title level={2}>NH Securities Vietnam</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 32 }}>
        Manage accounts, orders, and webhook integrations with NHSV.
      </Text>

      <Row gutter={[24, 24]}>
        {features.map(feature => (
          <Col xs={24} sm={12} lg={6} key={feature.href}>
            <Link to={feature.href}>
              <Card
                hoverable
                style={{ height: '100%' }}
                styles={{ body: { display: 'flex', flexDirection: 'column', gap: 12 } }}
              >
                {feature.icon}
                <Title level={5} style={{ margin: 0 }}>{feature.title}</Title>
                <Text type="secondary">{feature.description}</Text>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
